module.exports = __webpack_public_path__ + "static/media/m9.c247a0b5.jpeg";